import { RotateCw } from "lucide-react";
import { photoSessionTheme as t } from "./photoSessionTheme";

interface PhotoSessionRotateOverlayProps {
  title: string;
  hint: string;
}

export function PhotoSessionRotateOverlay({
  title,
  hint,
}: PhotoSessionRotateOverlayProps) {
  return (
    <div
      className="absolute inset-0 z-[80] flex flex-col items-center justify-center px-8 pointer-events-auto"
      style={{ backgroundColor: t.overlay }}
    >
      <div className="relative flex items-center justify-center">
        <div
          className="absolute h-20 w-20 rounded-full animate-ping opacity-40"
          style={{ backgroundColor: t.accent }}
        />
        <div
          className="relative flex h-20 w-20 items-center justify-center rounded-full ring-2"
          style={{
            backgroundColor: `${t.accent}22`,
            borderColor: `${t.accent}66`,
          }}
        >
          <RotateCw
            className="h-11 w-11 animate-[spin_2.5s_linear_infinite]"
            style={{ color: t.accent }}
            strokeWidth={2}
          />
        </div>
      </div>
      <p
        className="mt-8 text-lg font-bold text-center"
        style={{ color: t.text }}
      >
        {title}
      </p>
      <p
        className="mt-2 text-sm text-center max-w-sm leading-relaxed"
        style={{ color: t.textMuted }}
      >
        {hint}
      </p>
    </div>
  );
}
